import React, { useState, useLayoutEffect } from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import { usePreferences, ThemeProps } from "../usePreferences";

type Props = {
  fieldName: string;
  isValid: boolean;
  value?: string;
  onErrorText: string;
  onFieldChange(value: string): void;
};


type StyleProps = {
  isValid: Boolean;
} & ThemeProps;


const StyledTextField = styled(TextField)`
  && {
    & .MuiOutlinedInput-root {
      background: ${({ theme }: StyleProps) => theme.palette.background};
      color: ${({ theme }: StyleProps) => theme.palette.textColour};
      height: 50px;
      box-sizing: border-box;
      & fieldset {
        border-color: ${({ theme, isValid }: StyleProps) => isValid ? theme.palette.neutralActionColor: theme.palette.errorColour};
      }
    }
    & .MuiFormLabel-root {
      color: ${({ theme, isValid }: StyleProps) =>  isValid ? theme.palette.textColour : theme.palette.errorColour};
    }
    & .MuiInputAdornment-root {
      color: #000000;
    }
  }
`;

const HelperText = styled.div`
  color: ${({ theme, isValid }: StyleProps) =>  isValid ? theme.palette.textColour : theme.palette.errorColour};
  font-size: 12px;
  height: 15px;
  padding: 1px;
  margin-bottom: -15px;
`;

export const FieldEntry = ({
  fieldName,
  onErrorText,
  isValid = true,
  onFieldChange,
  value
}: Props) => {
  const [fieldValue, setFieldValue] = useState(value || "");
  const [preferences, _dispatch] = usePreferences();

  useLayoutEffect(() => {
    setFieldValue(value || "");
  }, [value]);

  const onTextChange = (newValue: string) => {
    setFieldValue(newValue);
    onFieldChange(newValue);
  };


  return (
    <div>
    <StyledTextField
      theme={preferences.theme}
      autoComplete={"off"}
      isValid={isValid}
      id="outlined-basic"
      label={fieldName}
      value={fieldValue}
      variant="outlined"
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        onTextChange(event && event.target && event.target.value)
      }
      error={!isValid}
    />
    { !isValid && <HelperText isValid={isValid} theme={preferences.theme}> {onErrorText} </HelperText> } 
 </div>
  );
};
